import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { Button, Field, Input } from "@redipos/ui";
import { auth } from "./session/authApi.js";
import { useSession } from "./session/SessionContext.js";

export default function LoginPage() {
  const { user, login } = useSession();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErr(null);
    setLoading(true);
    try {
      const data = await auth.login(email.trim().toLowerCase(), password);
      login(data);
    } catch (e2) {
      setErr(e2 instanceof Error ? e2.message : "Error de acceso");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="flex min-h-dvh items-center justify-center p-4 sm:p-6"
      style={{
        paddingTop: "max(1.5rem, env(safe-area-inset-top, 0px))",
        paddingBottom: "max(1.5rem, env(safe-area-inset-bottom, 0px))",
        paddingLeft: "max(1rem, env(safe-area-inset-left, 0px))",
        paddingRight: "max(1rem, env(safe-area-inset-right, 0px))",
      }}
    >
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center space-y-1">
          <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-brand-500">RediPOS</p>
          <h1 className="text-xl font-semibold text-fg">ERP</h1>
          <p className="text-xs text-fg-subtle">Hub de administración interna</p>
        </div>
        <form onSubmit={submit} className="rounded-card border border-border bg-surface/50 p-6 space-y-4 shadow-card">
          {err && (
            <p className="text-sm text-danger bg-danger-soft border border-danger/40 rounded-input px-3 py-2" role="alert">
              {err}
            </p>
          )}
          <Field label="Email" required>
            <Input type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </Field>
          <Field label="Contraseña" required>
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Field>
          <Button type="submit" loading={loading} loadingLabel="Entrando…" className="w-full">
            Entrar
          </Button>
        </form>
        <p className="text-center text-[11px] text-fg-subtle">
          Solo cuentas del equipo interno de RediPOS pueden ingresar.
        </p>
      </div>
    </div>
  );
}
